(() => {
  const categories = new Set(['all', 'home', 'self', 'gift']);
  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function initialize(root = document) {
    const header = document.querySelector('.sahara-header');
    if (header && !header.dataset.saharaMeasured) {
      header.dataset.saharaMeasured = 'true';
      const measure = () => {
        const height = header.getBoundingClientRect().height;
        document.body.style.setProperty('--header-height', `${height}px`);
        document.body.style.setProperty('--header-group-height', `${height}px`);
      };
      measure();
      if (window.ResizeObserver) new ResizeObserver(measure).observe(header);
    }
    root.querySelectorAll('[data-sahara-catalogue]').forEach((catalogue) => {
      if (catalogue.dataset.saharaInitialized) return;
      catalogue.dataset.saharaInitialized = 'true';
      const cards = [...catalogue.querySelectorAll('[data-sahara-piece]')];
      const filters = [...catalogue.querySelectorAll('[data-sahara-filter]')];
      const edit = catalogue.querySelector('.sahara-edit');
      catalogue.querySelector('[data-sahara-filters]').hidden = false;
      catalogue.querySelectorAll('[data-sahara-gallery]').forEach((gallery) => {
        const views = [...gallery.querySelectorAll('[data-gallery-view]')];
        const controls = [...gallery.querySelectorAll('[data-gallery-select]')];
        const select = (selected) => {
          views.forEach((view) => { view.hidden = view.dataset.galleryView !== selected; });
          controls.forEach((control) => control.setAttribute('aria-pressed', String(control.dataset.gallerySelect === selected)));
        };
        gallery.querySelector('[data-gallery-controls]').hidden = false;
        controls.forEach((control) => control.addEventListener('click', () => select(control.dataset.gallerySelect)));
        select('0');
      });
      const applyFilter = (category, scroll = false) => {
        if (!categories.has(category)) return;
        let count = 0;
        cards.forEach((card) => {
          card.hidden = category !== 'all' && card.dataset.category !== category;
          if (!card.hidden) count++;
        });
        filters.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.saharaFilter === category)));
        const results = catalogue.querySelector('[data-sahara-results]');
        results.textContent = results.dataset.countTemplate.replace('__COUNT__', String(count));
        catalogue.querySelector('[data-sahara-empty]').hidden = count !== 0;
        if (scroll) edit.scrollIntoView({ behavior: reducedMotion() ? 'instant' : 'smooth', block: 'start' });
      };
      filters.forEach((button) => button.addEventListener('click', () => applyFilter(button.dataset.saharaFilter)));
      catalogue.querySelectorAll('[data-sahara-detail]').forEach((details) => {
        if (!window.HTMLDialogElement || !HTMLDialogElement.prototype.showModal) return;
        const content = details.querySelector('.sahara-detail-content');
        const dialog = document.createElement('dialog');
        dialog.className = 'sahara-piece-dialog';
        dialog.setAttribute('aria-labelledby', content.querySelector('h2').id);
        const close = document.createElement('button');
        close.type = 'button';
        close.className = 'sahara-dialog-close';
        close.textContent = catalogue.dataset.closeLabel;
        const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        icon.setAttribute('viewBox', '0 0 24 24');
        icon.setAttribute('width', '20');
        icon.setAttribute('height', '20');
        icon.setAttribute('aria-hidden', 'true');
        const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path.setAttribute('d', 'm6 6 12 12M18 6 6 18');
        path.setAttribute('stroke', 'currentColor');
        path.setAttribute('stroke-width', '1.3');
        path.setAttribute('stroke-linecap', 'round');
        icon.append(path);
        close.append(icon);
        dialog.append(close, content);
        catalogue.append(dialog);
        close.addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', (event) => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        });
        const summary = details.querySelector('summary');
        summary.setAttribute('aria-haspopup', 'dialog');
        summary.addEventListener('click', (event) => {
          event.preventDefault();
          if (!dialog.open) dialog.showModal();
        });
        details.saharaOpen = () => { if (!dialog.open) dialog.showModal(); };
      });
      const hashCategory = window.location.hash.slice(1);
      applyFilter(categories.has(hashCategory) ? hashCategory : 'all', categories.has(hashCategory));
      catalogue.saharaApplyFilter = applyFilter;
    });
  }
  document.addEventListener('click', (event) => {
    const browse = event.target.closest('[data-sahara-browse]');
    const catalogue = document.querySelector('[data-sahara-catalogue]');
    if (browse && catalogue?.saharaApplyFilter) {
      event.preventDefault();
      catalogue.saharaApplyFilter(browse.dataset.saharaBrowse, true);
      document.querySelectorAll('.sahara-mobile-menu[open]').forEach((menu) => menu.removeAttribute('open'));
    }
    const closer = event.target.closest('[data-sahara-open-piece]');
    if (closer && catalogue) {
      const card = [...catalogue.querySelectorAll('[data-sahara-piece]')].find((piece) => piece.dataset.pieceKey === closer.dataset.saharaOpenPiece);
      const details = card?.querySelector('[data-sahara-detail]');
      if (details?.saharaOpen) {
        event.preventDefault();
        details.saharaOpen();
      }
    }
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') document.querySelectorAll('.sahara-mobile-menu[open]').forEach((menu) => menu.removeAttribute('open'));
  });
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const card = event.target.closest('[data-sahara-piece]');
    card?.closest('[data-sahara-catalogue]')?.saharaApplyFilter?.('all');
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
})();
